import React, { useState } from "react";
import {
    grantModerator,
    participantRoleChanged,
} from "../../../base/participants";
import { SignoutUser } from "../../firebase/firebaseActions";
import authService from "../../services/authService";
import Chat from "../../services/Chat";
import { firebaseDatabase } from "../../services/firebaseService";
import { UpdateMeetingStatus } from "../Meet/meet_actions";
import { SendCommandOnce, _getAllParticipants } from "./actions";
import { disconnect } from "../../../base/connection";
import { connect } from "../../../base/redux";
import Avatar from "../../../base/avatar/components/Avatar";

function EndButton({ src, btn_id, text, _meetDetail, _participants }) {
    const [type, setType] = useState("action_list");
    const [member, setMember] = useState([]);
    const [show, setShow] = useState(false);
    const [showEndBtn, setShowEndBtn] = useState(false); 

    const { uniquekey, is_owner } = _meetDetail || {};

    const { customerID, email } = authService.getUserDetail() || {};

    let isHost = parseInt(customerID) === parseInt(is_owner);

    const ShowEndBtnHandler = () => { 
        setShowEndBtn(!showEndBtn);
    };

    const ActionHandler = (type) => {
        setType(type);
        if (type === "action_list") {
            EndCall();
        } else {
            setShow(true);
        }
    };

    const grantModeratorHandler = async () => {
        if(member?.length > 0){
            let updateParticipants;
            const __UpdateUsers = (users, participantID) => {
                if (users?.participants) {
                    const { participants } = users;
                    updateParticipants = participants.map((value) => {
                        if (value.id === participantID) {
                            value["type"] = "coordinator";
                            return value;
                        }
                        return value;
                    });
                }
            };
            member &&
                member.forEach((element) => {
                    APP.store.dispatch(
                        participantRoleChanged(element?.id, "coordinator")
                    );
                    APP.store.dispatch(grantModerator(element?.id));
                    SendCommandOnce("role-changed", element?.id);

                    Chat.fetch_ref_on_update(`Groups/${uniquekey}`, (users) =>
                        __UpdateUsers(users, element?.id)
                    );
                    firebaseDatabase
                        .ref(`Groups/${uniquekey}/participants/`)
                        .update(updateParticipants);
                });
            setTimeout(() => {
                APP.store.dispatch(disconnect());
                authService.logout();
                SignoutUser();
                window.close();
            }, 1000);
        }else{
            swal({
                icon: "warning",
                title: "Warning!",
                text: "Please assign host before leaving the meet.",
                buttons: true,
            });
        }
    };

    const EndCall = async () => {
        if (isHost) {
            let response = await APP.store.dispatch(
                UpdateMeetingStatus({ status: "Completed", uniquekey })
            );
            if (response === 1) {
                SendCommandOnce("end-for-all", true);
            }
        } else {
            APP.store.dispatch(disconnect());
            authService.logout();
            window.close();
            SignoutUser();
        }
    };

    return (
        <div className="end-call-dropdown-main">
            <a
                className="nav-link "
                type="button"
                to={void 0}
                id={btn_id}
                onClick={ShowEndBtnHandler}
            >
                <img src={src} alt="chat" />
                <span className="text-13">{text}</span>
            </a>
            <div
                className={`end-call-dropdown ${
                    type === "participant_list" ? "w-290" : ""
                } ${showEndBtn ? "active" : ""}`}
                aria-labelledby={btn_id}
            >
                {type === "action_list" && (
                    <>
                        <a
                            className="dropdown-item"
                            href={void 0}
                            onClick={() => ActionHandler("action_list")}
                        >
                            {isHost && _participants?.length > 1
                                ? "End meeting for all"
                                : "Leave Meeting"}
                        </a>
                        {isHost && _participants?.length > 1 && (
                            <a
                                className="dropdown-item"
                                href={void 0}
                                onClick={() =>
                                    ActionHandler("participant_list")
                                }
                            >
                                Assign host and leave meeting
                            </a>
                        )}
                    </>
                )}

                {type === "participant_list" && (
                    <div className="new-host">
                        <h6>Select new host </h6>
                        <img
                            src="public/assets/images/invite-cross.svg"
                            alt="1"
                            className="close-host"
                            onClick={() => {
                                setType("action_list");
                                setShow(false);
                            }}
                        />
                        {member?.length > 0 && (
                            <>
                                <div className="select-host">
                                    {member.map((value, keys) => {
                                        return (
                                            <span
                                                className="select-host-profile-img"
                                                key={`profile${keys}`}
                                            >
                                                <Avatar
                                                    displayName={value.name}
                                                    size={48}
                                                    testId="participants.avatar"
                                                    url={value.avatarURL}
                                                />
                                                <span
                                                    onClick={() => {
                                                        member.filter(
                                                            (val) =>
                                                                val.id ===
                                                                value.id
                                                        ).length
                                                            ? setMember(
                                                                  member.filter(
                                                                      (val) =>
                                                                          val.id !=
                                                                          value.id
                                                                  )
                                                              )
                                                            : setMember([
                                                                  ...member,
                                                                  value,
                                                              ]);
                                                    }}
                                                >
                                                    <img
                                                        className="close-image"
                                                        src="public/assets/images/close.png"
                                                        alt="crown"
                                                    />
                                                </span>
                                            </span>
                                        );
                                    })}
                                </div>
                                <div className="border-bottom"></div>{" "}
                            </>
                        )}
                        <div className="new-host-list-scroll">
                            {_participants &&
                                _participants.map((value, index) => {
                                    if(value.name === "Recorder"){
                                        return null;
                                    }
                                    if (value.email === email) {
                                        return null;
                                    }
                                    return (
                                        <div
                                            className="new-host-list d-flex align-items-center justify-content-between"
                                            key={`part_${index}`}
                                        >
                                            <div className="name d-flex align-items-center">
                                                <Avatar
                                                    displayName={
                                                        value.firstname
                                                    }
                                                    size={48}
                                                    testId="participant.avatar"
                                                    url={value.avatarURL}
                                                />
                                                {/* <span className="host-online-ring"></span> */}
                                                <p>{value.name}</p>
                                            </div>
                                            <div
                                                className={`select-member-span ${
                                                    member.filter(
                                                        (val) =>
                                                            val.id === value.id
                                                    ).length
                                                        ? "active"
                                                        : ""
                                                }`}
                                                onClick={() => {
                                                    member.filter(
                                                        (val) =>
                                                            val.id === value.id
                                                    ).length
                                                        ? setMember(
                                                              member.filter(
                                                                  (val) =>
                                                                      val.id !=
                                                                      value.id
                                                              )
                                                          )
                                                        : member?.length < 2
                                                        ? setMember([
                                                              ...member,
                                                              value,
                                                          ])
                                                        : swal({
                                                              icon: "warning",
                                                              title: "Warning!",
                                                              text: "You cannot assign more than two host at a time.",
                                                              buttons: true,
                                                          });
                                                }}
                                            >
                                                <img
                                                    src="public/assets/images/tick-assign.svg"
                                                    alt="1"
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                            <a
                                href={void 0}
                                class="btn host-btn"
                                onClick={grantModeratorHandler}
                            >
                                Confirm and Leave
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

const _mapStateToProps = (state) => {
    return {
        _meetDetail: state["features/nxatel_meet"].meeting_details,
        _participants: _getAllParticipants(),
    };
};
export default connect(_mapStateToProps)(EndButton);
